import { WindowShapeTypes } from "building-types/settings/windowTypesEnum";
import { WindowVertDivisions } from "building-types/settings/windowTypesEnum";
import { ArchTopBoolean } from "building-types/settings/windowTypesEnum";
import type { WindowDescriptor } from "building-types/windows/windowTypes";
import type { LevelInches } from "common/types/nominalNumbersTypes";
import { mergeWithDefaultsAndOverrides } from "common/utils/mergeWithDefaultsAndOverrides";

export function windowDescriptorNew(
  opts: Partial<WindowDescriptor> & Pick<WindowDescriptor, "id" | "width" | "height" | "reportedName">,
): WindowDescriptor {
  return mergeWithDefaultsAndOverrides<WindowDescriptor>(
    {
      archBoolean: ArchTopBoolean.SUBTRACT,
      shape: WindowShapeTypes.RECTANGLE,
      verticalDivisions: WindowVertDivisions.SINGLE,
      angleVerticalOffset: 0,
      polygonWindowMode: undefined,
    },
    opts,
    {
      catalogItemType: "WINDOW_DESCRIPTOR",
    },
  );
}

export function windowDescriptorSetSize(desc: WindowDescriptor, width: LevelInches, height: LevelInches) {
  return windowDescriptorNew({
    ...desc,
    width,
    height,
  });
}
